<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { useChecklistControllerStore } from "~/composables/useChecklistControllerStore";

const documentId = inject("documentId") as any;
const checklistController = useChecklistControllerStore(documentId);
const { currentChecklistCriteriaInstance, checklistControllerMode } =
  storeToRefs(checklistController);

const documentChecklistStore = useDocumentChecklistStore(documentId);
const { isInitialized } = storeToRefs(documentChecklistStore);

const documentViewModeStore = useDocumentViewModeStore(documentId);
const { isTeacherViewMode } = storeToRefs(documentViewModeStore);
</script>

<template>
  <div class="h-full">
    <div v-if="isInitialized != true" class="h-full p-4 flex flex-col">
      <div class="border-b pb-2 mb-4">
        <BaseSkeleton class="h-[22px] w-[300px]" />
      </div>
      <div v-for="i in 4" :key="i" class="flex flex-col gap-2 mb-6">
        <BaseSkeleton class="h-[18px] w-[150px]" />
        <div
          v-for="i in 5"
          :key="i"
          class="flex flex-row items-center justify-between gap-2"
        >
          <BaseSkeleton class="h-[18px] grow" />
          <div class="flex flex-row items-center gap-2">
            <BaseSkeleton class="h-[30px] w-[30px]" />
            <BaseSkeleton class="h-[30px] w-[30px]" />
          </div>
        </div>
      </div>
    </div>
    <DocumentPanelChecklistWrapper
      v-if="checklistControllerMode == ChecklistControllerMode.reviewSteps"
    />
    <ChecklistCriteriaWrapper
      v-if="
        checklistControllerMode == ChecklistControllerMode.summary &&
        currentChecklistCriteriaInstance &&
        currentChecklistCriteriaInstance.checklistCriteriaId
      "
      :criteria-instance="currentChecklistCriteriaInstance"
      :checklist-criteria="
        checklistController.getCriteriaFromId(
          currentChecklistCriteriaInstance.checklistCriteriaId
        )!
      "
      class="h-full"
    />

    <ChecklistSummary
      v-if="
        checklistControllerMode == ChecklistControllerMode.summary &&
        !currentChecklistCriteriaInstance
      "
      class="h-full"
    />
  </div>
</template>

<style scoped></style>
